import React from 'react';


const Overview = () => {
  return (
<>

<h3>A Landslide has occurred/is expected to occur in the region of Timor-Leste. Due to intense and prolonged rainfall
forecast for next [HOUR]hours, the risk of landslides has significantly increased. Based on rainfall accumulation
data, ground saturation levels, and slope conditions, several areas are now at high risk for landslide activity.</h3>
</>
  );
};

export default Overview;
